<template>
    <div class="card future-settings-box arrow_box">
        <div class="card-header">
            Pending Changes
        </div>
        <div class="card-body">
            <p>
                Min Age: {{ futureSettings.minAge }}
            </p>
            <p>
                Max Age: {{ futureSettings.maxAge }}
            </p>
            <p>
                Price: {{ futureSettings.price | currency }}
            </p>
            <p>
                Effective Date: {{ futureSettings.effectiveDate | shortDate }}
            </p>
        </div>
    </div>
</template>

<script>

    export default {
        name: "FuturePriceTier",
        props: {
            futureSettings: {type: [Object], required: true},
        },
        methods: {
            viewFuturePriceTier(priceTier) {
                this.mapData('futureSettings', {...priceTier.futureSettings, effectiveDate: priceTier.futureSettings.effectiveDate});
                this.$refs.futureSettingsModal.open();
            },
        },
        async mounted() {
        },
    }
</script>

<style scoped>
    .future-settings-box {
        position: absolute;
        bottom: 13px;
        width: 200px;
        height: 158px;
        right: -90px;
        z-index: 100;
    }

    .card-header {
        color: #2a9a71;
        padding: 9px 4px 3px 20px;
        margin: 0;
    }

    .card-body {
        padding-top: 8px;
    }

    .arrow_box:after,
    .arrow_box:before {
        bottom: 100%;
        border: solid transparent;
        content: " ";
        height: 0;
        width: 0;
        position: absolute;
        pointer-events: none;
        transform: rotate(179deg);
        bottom: -30px;
    }

    .arrow_box:after {
        border-color: rgba(255, 255, 255, 0);
        border-bottom-color: #ffffff;
        border-width: 15px;
        left: 50%;
        margin-left: -19px;
    }

    .arrow_box:before {
        border-color: rgba(113, 158, 206, 0);
        border-bottom-color: #cecece;
        border-width: 14px;
        left: 50%;
        margin-left: -18px;
    }
</style>